/**
 * Attachment Source Types
 *
 * Defines the valid source types for ApplicationAttachment records.
 * These represent where an attachment was uploaded from.
 *
 * Note: Keep in sync with backend constant at:
 * financial-navigation/application/builder/src/api/constants/attachmentSources.js
 *
 * @constant {Object} ATTACHMENT_SOURCES
 * @property {string} FORM - Attachments uploaded within the enrollment form
 * @property {string} ATTACHMENTS_TAB - Attachments uploaded from the attachments tab
 * @property {string} OLD_FILE - Legacy attachments migrated from old system
 */
export const ATTACHMENT_SOURCES = {
  FORM: "FORM",
  ATTACHMENTS_TAB: "ATTACHMENTS_TAB",
  OLD_FILE: "OLD_FILE"
};

/**
 * Array of all valid attachment source values
 * Useful for validation and filtering
 */
export const ATTACHMENT_SOURCE_VALUES = Object.values(ATTACHMENT_SOURCES);

/**
 * Default source for backward compatibility
 */
export const DEFAULT_ATTACHMENT_SOURCE = ATTACHMENT_SOURCES.ATTACHMENTS_TAB;
